import React, { useEffect } from "react";

import { useNavigate, Link } from "react-router-dom";

import { Container, Button } from "react-bootstrap";

import { RiCreativeCommonsByFill } from "react-icons/ri";
import { FiLogIn } from "react-icons/fi";

/**
 * @author
 * @function Index
 **/

const Index = ({ jwt }) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (jwt) {
      navigate("/home");
    }
  }, [jwt, navigate]);

  return (
    <div className="page-wrapper">
      <Container className="text-center mt-5 content-wrapper">
        <h1>Welcome the Onriva Account Management Tool</h1>
        <p className="lead">Your view into the system</p>
        <Link to="/login">
          <Button variant="primary" size="md" className="my-3">
            <FiLogIn /> Go to Login
          </Button>
        </Link>
      </Container>
      <footer className="footer">
        <div className="footer-icon">
          <RiCreativeCommonsByFill size={50} />
        </div>
        <div className="footer-text">
          <p>Manage Accounts faster than ever before</p>
        </div>
      </footer>
    </div>
  );
};

export default Index;
